import { FC } from 'react'
import * as React from 'react'

import BlazeAvatar from './BlazeAvatar'
import AlmanacAvatar from './AlmanacAvatar'
import { RenderedSVGComponent } from 'types'

export interface Props {
  altText?: string
  className?: string
  backgroundColor?: string
  color?: string
  emoji?: string | RenderedSVGComponent
  label?: string
  loading?: boolean
  size?: number
  url?: string | null
  seed?: number
  title?: string
  randomColor?: boolean
  staticColor?: boolean
  onClick?: (e: React.MouseEvent) => void
  workspaceId?: number
  borderColor?: string
}

const Avatar: FC<React.PropsWithChildren<Props>> = (props) => {
  if (!!props.workspaceId) return <BlazeAvatar {...props} />

  return <AlmanacAvatar {...props} />
}
export default Avatar
